import React from 'react';

import { Nav } from '../components/Nav-de';
import { Hero } from './parts/Hero-de';
import { About } from './parts/About-de';
import { Offer } from './parts/Offer-de';
import { CTA } from './parts/CTA-de';
import { Footer } from '../components/Footer-de';
import { MetaTagsComponent } from '../components/MetaTags';

const Home = () => {
  return (
    <>
      <MetaTagsComponent lang="de" />
      <Nav />
      <Hero />
      <About />
      <Offer />
      <CTA />
      <Footer />
    </>
  );
};

export { Home };